if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form){
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
    }



    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');

      const bold_option = $(document).find($('.bold_option.bold_option_textbox .bold_option_element input')).val();
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      config.body = formData;

    if(bold_option != ""){
      fetch(`${routes.cart_add_url}`,  config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response)
            Cart.Update_cart_count();
            Cart.Update_cart_popup();
            this.successPopup();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
          });
    }else{
        $('.product-addToCart').modal('hide')
    }
      (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
    }
    successPopup(){
        $('#productView-1').modal('hide');
        $('.product-addToCart__close').click();
        $('.js-header-catalog-overlay').removeClass('active');
        $('.js-header-catalog-menu-toggle').removeClass('active');
        $('.js-header-catalog').removeClass('show');
        setTimeout(function (){
            $('.success_popup').removeClass('hidden');
            $('.success_popup').addClass('animation');
        },300)
        setTimeout(function (){
            $('.success_popup').addClass('hidden');
            $('.success_popup').removeClass('animation');
        },5000)
      (typeof window.BOLD !== 'undefined' && typeof window.BOLD.common !== 'undefined' && typeof window.BOLD.common.eventEmitter !== 'undefined' && typeof window.BOLD.common.eventEmitter.emit !== 'undefined' && (BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded')));
    }

  });
}
